import { useDictionary, type UseDictionaryOptions } from './useDictionary';

type AssetsDictionaryOptions = Omit<
  UseDictionaryOptions<Record<string, string>>,
  'dictionaryName'
>;

export type AssetsIcons = Record<string, string>;

const useAssetsIcons = (options: AssetsDictionaryOptions = {}) => {
  const {
    data: assetsIconsData,
    isLoading: isAssetsIconsLoading,
    error: assetsIconsError,
    refetch: refetchAssetsIcons,
  } = useDictionary<AssetsIcons>({
    dictionaryName: 'asseticons',
    ...options,
  });

  return {
    assetsIconsData,
    isAssetsIconsLoading,
    assetsIconsError,
    refetchAssetsIcons,
  };
};

export { useAssetsIcons };
